import React from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row"
import BarChart from "../../charts/BarChart/BarChart";

const BarWidget = ({ title, subtitle, chartClassName, options = {}, locale, showTitle, showSubtitle, error = "", data = {}, verticalOrientation, altLabelsCheck = null }) => {

  let labels = data.labels;
  
  if(altLabelsCheck){
    if(window.innerWidth <= altLabelsCheck){
      labels = data.altLabels;
    }
  }

  return (
        <Card.Body>
          <Row className="h-25 d-block d-xl-flex align-items-center">
            {(showTitle) &&
              <Col xs={12} className="px-xl-0">
                <h5 className="mb-2">{error ? "Service unavailable" : title}</h5>
              </Col>
            }
            {showSubtitle && <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
              <h6 className="mt-1 mb-1">{subtitle}</h6>
            </Col>}
            <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
              <BarChart
                locale={locale}
                labels={labels}
                series={data.series}
                chartClassName={chartClassName}
                options={options}
                verticalOrientation={verticalOrientation}
              />
            </Col>
          </Row>
        </Card.Body>
    );
  };

export default BarWidget;